import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./styles.css";
import { VERSION } from "./version.js";
import { report, LEVELS, EVENTS } from "./lib/report.js";

/* A thrown error used to unmount the whole tree and leave a white screen with
   nothing but a console trace. Now it shows what broke and how to recover. */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error("Composer crashed:", error, info);
    report(LEVELS.critical, EVENTS.APP_CRASHED, {
      message: String(error?.stack || error).slice(0, 800),
      context: (info?.componentStack || "").split("\n")[1]?.trim() || "",
    });
  }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{
        fontFamily: "Barlow, system-ui, sans-serif", maxWidth: 620, margin: "60px auto",
        background: "#fff", border: "1px solid #E1E6E9", borderRadius: 8, padding: 28,
      }}>
        <h2 style={{ margin: "0 0 6px", fontSize: 20 }}>Something broke</h2>
        <p style={{ margin: "0 0 18px", fontSize: 14, lineHeight: 1.6, color: "#5D6D77" }}>
          Your work is saved in this browser, so reloading should bring it back.
          If it happens again, send this message to Adam.
        </p>
        <pre style={{
          background: "#F7F8F9", border: "1px solid #E1E6E9", borderRadius: 5, padding: 12,
          fontSize: 12, lineHeight: 1.5, whiteSpace: "pre-wrap", wordBreak: "break-word",
          color: "#8C1024", margin: "0 0 18px",
        }}>{VERSION}{"\n"}{String(this.state.error?.stack || this.state.error)}</pre>
        <button
          onClick={() => window.location.reload()}
          style={{
            border: 0, borderRadius: 4, padding: "11px 18px", cursor: "pointer",
            background: "#0080C6", color: "#fff", fontFamily: "Barlow Condensed, sans-serif",
            textTransform: "uppercase", letterSpacing: ".1em", fontWeight: 600, fontSize: 12.5,
          }}>Reload</button>
      </div>
    );
  }
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
